import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-startup-enterprises",
  templateUrl: "./startup-enterprises.component.html",
  styleUrls: ["./startup-enterprises.component.scss"],
})
export class StartupEnterprisesComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);

    $('.float-nav').click(function () {
      $('.float-main-nav, .menu-btn').toggleClass('active');
    });
  }
}
